import SimpleText from "@/components/texts/simpleText";
import Button from "@/components/inputs/button";
import ContentSpace from "@/components/spaces/contentSpace";
import ButtonLinkUndescore from "@/components/inputs/buttonLinkUnderscore";
import {GET_ALL_STATE, SET_USER_STEP, SET_USER_TAB} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import {GET_USER, SET_USER_ALERT} from "@/store/slices/userSlice";
import {useCookies} from "react-cookie";
import {SET_LEAD_CELULAR, SET_LEAD_URL, SET_LEAD_USER_LOAD} from "@/store/slices/leadSlice";
import {useState} from "react";
import themes from "@/styles/themes";
import Events from "@/utils/Events";
import Lead from "@/utils/Lead";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import Apm from "@/utils/Apm";
import AtualizarTelefone from "@/components/modals/atualizarTelefone";
import { setAuthMethod } from "@/utils/AuthMethod";

const Autenticado = () => {
   
    const events = new Events()
    const dispatch = useDispatch();
    const USER = useSelector(GET_USER)
    const cookies = useCookies()[0];
    const [lead] = useState(false);
    const removeCookie = useCookies()[2];
    const all_states = useSelector(GET_ALL_STATE)
    const offer_type = useSelector(GET_OFFER_TYPE)

    const cookiesList = ['OESP_INFO', 'PORTAL_AUTH', 'OESP_GA_GID', 'OESP_LGPD_ACEITE', 'PORTAL_LOGIN', 'blaize_jwt']

    dispatch(SET_USER_ALERT({show: false}))
    
    if (all_states.lead.value.email === null) {
        dispatch(SET_LEAD_USER_LOAD(cookies.OESP_INFO))

    } else {
        dispatch(SET_LEAD_URL(window.location.href))
        if(!lead){
            Lead.save(all_states.lead.value, dispatch)
        }
    }
    if(all_states.lead.value.mobile === null) {
        dispatch(SET_LEAD_CELULAR(cookies.OESP_INFO.telefone))
    }

    function ValidateTelefone() {
        return USER.telefone && USER.telefone.trim().length >= 8
    }

    function nextStep() {
        events.trigger("identificacao_logado_continuar", { offer_type })
        dispatch(SET_USER_STEP(2))
        events.trigger("identificacao_logado_continuar_sucesso", { offer_type })
    }

    function logout() {
        events.trigger("identificacao_logado_trocar_usuario", { offer_type })
        if (!ValidateTelefone()) {
            events.trigger("atualizacao_celular_outra_conta", { offer_type })
        }
        setAuthMethod('trocando_conta')
        cookiesList.forEach((item) => {
            if (cookies.hasOwnProperty(item)) {
                removeCookie(item, {path: '/', domain: '.estadao.com.br'})
            }
        })
        dispatch(SET_USER_TAB(0))
    }

    USER?.email && Apm.setUserContext({
        email: USER?.email,
        id: USER?.id_usuario
    });

    return (
        <ContentSpace>
            <SimpleText style={{margin: '0 0 12px 0', lineHeight:'1.63'}} color={'#000'}>
                Você está logado como <b>{USER.nome} {USER.sobre_nome}</b> <br/> {USER.email}
            </SimpleText>
            {ValidateTelefone() ? <Button id="continuar_step_1" data-transaction-name="continuar" className={'submit'} onClick={nextStep}>Continuar</Button>: ''}
            {!ValidateTelefone() ? <AtualizarTelefone actionAfter={nextStep}></AtualizarTelefone>: ''}
            <div className={'text--center'}>
                <ButtonLinkUndescore data-transaction-name="Entrar com outra conta" className={'enter'} color={themes.estadao} onClick={logout}>Entrar com outra conta.</ButtonLinkUndescore>
            </div>
        </ContentSpace>
    )
}

export default Autenticado